import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import DateTimeformatter from '../../../services/ui/datetime/dateTimeFormatter';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import CountriesDropdown from '../../portal/countriesDropdown';
import LanguagesDropdownContainer from '../../portal/languagesDropdown';
import PortalDatePicker from '../../portal/portalDatePicker';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import ActivateUser from './activateUser';
import AddEditUserScrollbars from './addEditUserScrollbars';
import styles from './style.scss';

@inject('translationsStore', 'oidcStore', 'usersStore', 'addEditUserStore', 'systemLocalesStore') @observer
export default class UserEditGeneralForm extends Component {

    fieldsWidth = '325px';

    constructor(props) {

        super(props);

        this.shouldFieldDisabled = this.props.addEditUserStore.isNotLocalAuthenticationType();
    }

    handleChangeFirstName = e => this.props.addEditUserStore.setFirstName(e.target.value);
    handleFirstNameOnBlur = e => this.props.addEditUserStore.validateFirstName();

    handleChangeLastName = e => this.props.addEditUserStore.setLastName(e.target.value);
    handleLastNameOnBlur = e => this.props.addEditUserStore.validateLastName();
    
    handleChangeEmail = e => this.props.addEditUserStore.setEmail(e.target.value);
    handleEmailOnBlur = e => this.props.addEditUserStore.validateEmail();

    handleChangeJobTitle = e => this.props.addEditUserStore.setJobTitle(e.target.value);
    
    handleChangePhoneNumber = e => this.props.addEditUserStore.setPhoneNumber(e.target.value);
    handleChangeCellPhoneNumber = e => this.props.addEditUserStore.setCellPhoneNumber(e.target.value);
    handleChangeOther = e => this.props.addEditUserStore.setOther(e.target.value);

    handleChangeActive = e => this.props.addEditUserStore.setActive(e.target.checked);
        
    handleChangeExpirationDate = (e, date) => this.props.addEditUserStore.setExpirationDate(date);
    handleChangeAllowedIpList = e => this.props.addEditUserStore.setAllowedIpList(e.target.value);
    handleChangeLocaleId = (e, index, value) => this.props.addEditUserStore.setLocaleId(value);

    handleCountriesDropdownChange = (e, index, value) => this.props.addEditUserStore.setCountry(value);

    getDatesForDatePicker() {

        let expirationDate = new Date();

        if (this.props.addEditUserStore.values.expirationDate !== null 
                && this.props.addEditUserStore.values.expirationDate !== '') {

            expirationDate = new Date(this.props.addEditUserStore.values.expirationDate);
        }

        return {
            defaultDate: expirationDate,
            minDate: this.props.addEditUserStore.calulateMinValidDate()
        };
    }

    render(){

        const { values } = this.props.addEditUserStore;
        const { currentUser } = this.props.oidcStore;

        const dates = this.getDatesForDatePicker();
        const dateTimeformatter = new DateTimeformatter();
        const locale = currentUser.profile.locale
        const dateTimeFormat = dateTimeformatter.getDateTimeFormat(locale);

        return (
            <div>
                <ValidationTopErrorMessage errorMessage={this.props.addEditUserStore.addUserErrorMessage} />
                <AddEditUserScrollbars
                    height='53vh'
                >   
                    <div className={classNames(styles.userFormWrapper)}>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('FIRST_NAME')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('FIRST_NAME')} required />}
                                onChange={this.handleChangeFirstName}
                                onBlur={this.handleFirstNameOnBlur}
                                errorText={this.props.addEditUserStore.firstNameValidationMessage}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.firstName}
                                width={this.fieldsWidth}
                                dataCy='first-name-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('LAST_NAME')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('LAST_NAME')} required />}
                                onChange={this.handleChangeLastName}
                                onBlur={this.handleLastNameOnBlur}
                                errorText={this.props.addEditUserStore.lastNameValidationMessage}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.lastName}
                                width={this.fieldsWidth}
                                dataCy='last-name-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('USER_NAME')}
                                floatingLabelText={this.props.translationsStore.translate('USER_NAME')}
                                disabled={true}
                                value={values.userName}
                                width={this.fieldsWidth}
                                dataCy='user-name-field'
                            />
                        </div>                   
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('EMAIL')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('EMAIL')} required />}
                                onChange={this.handleChangeEmail}
                                onBlur={this.handleEmailOnBlur}
                                errorText={this.props.addEditUserStore.emailValidationMessage}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.email}
                                width={this.fieldsWidth}
                                dataCy='email-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('JOB_TITLE')}
                                floatingLabelText={this.props.translationsStore.translate('JOB_TITLE')}
                                onChange={this.handleChangeJobTitle}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.jobTitle}
                                width={this.fieldsWidth}
                                dataCy='job-title-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('PHONE')}
                                floatingLabelText={this.props.translationsStore.translate('PHONE')}
                                onChange={this.handleChangePhoneNumber}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.phoneNumber}
                                width={this.fieldsWidth}
                                dataCy='phone-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('MOBILE_PHONE')}
                                floatingLabelText={this.props.translationsStore.translate('MOBILE_PHONE')}
                                onChange={this.handleChangeCellPhoneNumber}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.cellPhoneNumber}
                                width={this.fieldsWidth}
                                dataCy='mobile-phone-field'
                            />
                        </div>
                        <div>
                            <CountriesDropdown
                                hintText={this.props.translationsStore.translate('COUNTRY')}
                                floatingLabelText={this.props.translationsStore.translate('COUNTRY')}
                                onChange={this.handleCountriesDropdownChange}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.country}
                                width={this.fieldsWidth}
                                translations={{
                                    selectCountry: this.props.translationsStore.translate('SELECT_COUNTRY')
                                }}
                                dataCy='select-country-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('OTHER')}
                                floatingLabelText={this.props.translationsStore.translate('OTHER')}
                                onChange={this.handleChangeOther}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.other}
                                width={this.fieldsWidth}
                                dataCy='other-field'
                            />
                        </div>                                           
                        <div>
                            <LanguagesDropdownContainer
                                hintText={this.props.translationsStore.translate('LOCALE')}
                                floatingLabelText={this.props.translationsStore.translate('LOCALE')}
                                onChange={this.handleChangeLocaleId}
                                disabled={this.props.addEditUserStore.updatingUser}
                                value={values.localeId}
                                width={this.fieldsWidth}
                                dataCy='locale-field'
                            />
                        </div>
                        <div>
                            <PortalDatePicker
                                floatingLabelText={this.props.translationsStore.translate('EXPIRATION_DATE')}
                                hintText={this.props.translationsStore.translate('EXPIRATION_DATE')}
                                okLabel={this.props.translationsStore.translate('DONE')}
                                cancelLabel={this.props.translationsStore.translate('CANCEL')}
                                onChange={this.handleChangeExpirationDate}
                                DateTimeFormat={dateTimeFormat}
                                defaultDate={dates.defaultDate}
                                minDate={dates.minDate}
                                disabled={this.props.addEditUserStore.updatingUser || this.shouldFieldDisabled}
                                width={this.fieldsWidth}
                                data-cy='expiraion-date-field'
                            />
                        </div>
                        <div>
                            <PortalTextBox
                                hintText={this.props.translationsStore.translate('AUTHENTICATION_PROVIDER')}
                                floatingLabelText={this.props.translationsStore.translate('AUTHENTICATION_PROVIDER')}
                                disabled={true}
                                value={values.authenticationProviderFormatted}
                                width={this.fieldsWidth}
                                dataCy='authentication-provider-field'
                            />
                        </div>                 
                    </div>
                    <div>
                        <ActivateUser 
                            onChange={this.handleChangeActive}
                            checked={values.active}
                            userId={values.id}
                            currentUserId={parseInt(currentUser.profile.sub)}
                            title={this.props.translationsStore.translate('ACTIVE_USER')}
                            dataCy='active-user-toggle'
                        />
                    </div>
                    <button type='submit' style={{display: 'none'}}/>
                </AddEditUserScrollbars>
            </div>
        );
    }
}